import { render, staticRenderFns } from "./bind-phone.vue?vue&type=template&id=4836ee1e&scoped=true&lang=pug"
import script from "./bind-phone.vue?vue&type=script&lang=ts"
export * from "./bind-phone.vue?vue&type=script&lang=ts"
import style0 from "./bind-phone.vue?vue&type=style&index=0&id=4836ee1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4836ee1e",
  null
  
)

export default component.exports